// extracted by mini-css-extract-plugin
export default {"offer--exit-active":"youroffers--1jXTF","offer--exited":"youroffers--KCyBG"};